import { FC, MutableRefObject, forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import V2Drawer, { V2DrawerHandles } from 'src/common/components/Feedback/V2Drawer/index';
import Detail from '@/views/expandstore/pages/expansionFranchiseeCircleTask/pages/detail';
import { useMethods } from '@lhb/hook';

const LocxxTaskDetailDrawer: FC<{
  reload?: () => void;
  onClose?: () => void;
  open?: boolean;
  taskId?: number | string;
  onEdit?: (taskId: number | string) => void;
  ref?: any;
}> = forwardRef(({ reload, onClose, open: controlledOpen, taskId: controlledTaskId }, ref) => {
  const [id, setId] = useState<number | string>();
  const [open, setOpen] = useState(false);
  const drawerWrapper: MutableRefObject<V2DrawerHandles | null> = useRef(null);
  const detail: any = useRef();

  useImperativeHandle(ref, () => ({ init }));

  useEffect(() => {
    if (controlledOpen && controlledTaskId) {
      setId(controlledTaskId);
      setOpen(true);
      setTimeout(() => detail.current?.init?.(), 0);
    } else if (controlledOpen === false) {
      setOpen(false);
    }
  }, [controlledOpen, controlledTaskId]);

  const init = (taskId: number | string) => {
    setId(taskId);
    setOpen(true);
    setTimeout(() => {
      drawerWrapper.current?.getBodyElement().scrollTo({ top: 0 });
      detail.current?.init?.();
    }, 0);
  };

  const methods = useMethods({
    handleClose() {
      setOpen(false);
      onClose?.();
    },
  });

  return (
    <V2Drawer
      onRef={drawerWrapper}
      open={open}
      onClose={methods.handleClose}
      maskClosable={false}
      push={false}
      bodyStyle={{ padding: 0 }}
    >
      {open ? (
        <Detail
          ref={detail}
          id={id}
          reload={reload}
          isLocxx
          hideOperate={false}
          hideClusterDetail={false}
        />
      ) : null}
    </V2Drawer>
  );
});

export default LocxxTaskDetailDrawer;
